import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Placeholder for image component from Remix
export default function Link(props) {
    return _jsx("a", { href: props.to, target: "_blank", ...props });
}
